export default __webpack_public_path__ + "static/media/products3.d144cfc4.png";